import { AuthServiceInterface } from '@freelancer/auth/interface';
import {
  AdminEnterprisesCollection,
  AdminPoolsCollection,
  AdminUserEnterprisesCollection,
  BannersCollection,
  BidRestrictionsCollection,
  BidsCollection,
  BidSummariesCollection,
  BidUpgradeFeesCollection,
  BillingAgreementsCollection,
  CanViewEmployerProfileCollection,
  CategoryPageContentCollection,
  CertificationsCollection,
  CommentFeedsCollection,
  CommentsCollection,
  ContestBudgetRangesCollection,
  ContestCommentsCollection,
  ContestEntriesCollection,
  ContestFeesCollection,
  ContestQuickviewEntriesCollection,
  ContestsCollection,
  ContestViewContestsCollection,
  ContestViewEntriesCollection,
  ContestViewEntryIdsCollection,
  CountriesCollection,
  CurrenciesCollection,
  CurrenciesIncludingExternalCollection,
  CustomFieldInfoConfigurationsCollection,
  DashboardWidgetsCollection,
  DepositPageVarsCollection,
  DomainsCollection,
  EducationsCollection,
  EncodedUrlCollection,
  EnterpriseBillingAgreementsBalanceCollection,
  EnterprisesCollection,
  ExamsCollection,
  ExchangeRatesCollection,
  ExperiencesCollection,
  FeedCollection,
  FeedMetaCollection,
  FeedPostsCollection,
  FreelancerReputationsCollection,
  FreelancerReputationsRehireRatesCollection,
  generateAdminEnterpriseObjects,
  GenerateAdminEnterpriseOptions,
  generateAdminPoolObjects,
  GenerateAdminPoolOptions,
  generateBannerObjects,
  generateBidObjects,
  generateBidRestrictionsObject,
  GenerateBidRestrictionsOptions,
  GenerateBidsOptions,
  generateBidSummariesObject,
  GenerateBidSummariesOptions,
  generateBidUpgradeFeesObject,
  GenerateBidUpgradeFeesOptions,
  generateBillingAgreementObject,
  GenerateBillingAgreementOptions,
  generateCanViewEmployerProfileObject,
  GenerateCanViewEmployerProfileOptions,
  generateCategoryPageContent,
  GenerateCategoryPageContentOptions,
  generateCertificationObject,
  GenerateCertificationOptions,
  generateCommentFeedObject,
  GenerateCommentFeedOptions,
  generateCommentObject,
  generateCommentObjects,
  GenerateCommentOption,
  generateContestBudgetRangesObjects,
  GenerateContestEntriesOptions,
  generateContestEntryObject,
  generateContestEntryObjects,
  GenerateContestEntryOptions,
  generateContestFeesObject,
  GenerateContestFeesOptions,
  generateContestObject,
  GenerateContestOptions,
  GenerateContestQuickviewEntriesOptions,
  generateContestQuickviewEntryObjects,
  generateContestViewContestObject,
  GenerateContestViewContestOptions,
  GenerateContestViewEntriesOptions,
  generateContestViewEntryIdsObject,
  GenerateContestViewEntryIdsOptions,
  generateContestViewEntryObjects,
  GenerateCountriesOptions,
  generateCountryObjects,
  generateCurrencyIncludingExternalObjects,
  generateCurrencyObjects,
  generateCustomFieldInfoConfigurationObjects,
  GenerateCustomFieldInfoConfigurationOptions,
  generateDashboardWidgetObjects,
  GenerateDashboardWidgetsOptions,
  generateDepositPageVarsObjects,
  GenerateDepositPageVarsOptions,
  generateDomainObject,
  generateEducationObject,
  GenerateEducationOptions,
  generateEncodedUrlObject,
  GenerateEncodedUrlOptions,
  generateEnterpriseBillingAgreementsBalance,
  GenerateEnterpriseBillingAgreementsBalanceOptions,
  generateEnterpriseObjects,
  GenerateEnterpriseOptions,
  generateExamObjects,
  generateExchangeRateObject,
  GenerateExchangeRatesOptions,
  generateExperienceObject,
  GenerateExperienceOptions,
  generateFeedMetaObjects,
  GenerateFeedMetaOptions,
  generateFeedObject,
  GenerateFeedOptions,
  generateFeedPostObjects,
  GenerateFeedPostsOptions,
  GenerateFreelancerReputationOptions,
  generateFreelancerReputationsObject,
  generateFreelancerReputationsObjects,
  GenerateFreelancerReputationsOptions,
  generateFreelancerReputationsRehireRatesObject,
  generateFreelancerReputationsRehireRatesObjects,
  GenerateGrantItemOptions,
  generateGrantsObjects,
  GenerateGroupMemberOptions,
  generateGroupMembersObject,
  GenerateGroupOptions,
  generateGroupPermissionsObject,
  GenerateGroupPermissionsOptions,
  GenerateGroupSelfOptions,
  generateGroupsObject,
  generateGroupsSelf,
  generateHourlyContractObject,
  GenerateHourlyContractOptions,
  generateLanguagesObject,
  generateManageViewOngoingBidObjects,
  GenerateManageViewOngoingBidsOptions,
  generateManageViewOpenBidsObjects,
  GenerateManageViewOpenBidsOptions,
  generateMembershipBenefitObject,
  GenerateMembershipBenefitOptions,
  generateMembershipPackagesObjects,
  generateMembershipSubscriptionHistoryObjects,
  GenerateMembershipSubscriptionHistoryOptions,
  generateMembershipTrialsObjects,
  generateMessage,
  GenerateMessageOptions,
  generateMessages,
  GenerateMessagesOptions,
  generateMilestoneObject,
  GenerateMilestoneOptions,
  generateNativeExchangeRateObject,
  GenerateNativeExchangeRatesOptions,
  generateNotificationAcceptedObject,
  generateNotificationAwardObject,
  GenerateNotificationAwardOptions,
  generateNotificationBidObject,
  GenerateNotificationBidOptions,
  generateNotificationBookmarkedProjecAwardedObject,
  GenerateNotificationBookmarkedProjecAwardedOptions,
  generateNotificationPreferenceObjects,
  GenerateNotificationPreferenceObjectsOptions,
  GenerateNotificationProjectAcceptedOptions,
  generateOnBehalfProject,
  GenerateOnBehalfProjectOptions,
  generateOnlineOfflineObjects,
  GenerateOnlineOfflineOptions,
  generateParentContestCommentObject,
  GenerateParentContestCommentOptions,
  generatePaymentShareMemberObject,
  GeneratePaymentShareMemberOptions,
  generatePaymentShareMemberSpentAmountObject,
  GeneratePaymentShareMemberSpentAmountOptions,
  generatePaymentShareTeamObject,
  GeneratePaymentShareTeamOptions,
  generatePaymentShareWhitelistItemObject,
  GeneratePaymentShareWhitelistItemOptions,
  generatePoolObjects,
  GeneratePoolOptions,
  generatePortfolioObject,
  generatePortfolioObjects,
  GeneratePortfolioOptions,
  GeneratePortfoliosOptions,
  generatePredictedSkillsObject,
  GeneratePredictedSkillsOptions,
  generatePreferredBillingAgreementObject,
  GeneratePreferredBillingAgreementOptions,
  generateProfileViewUserObject,
  generateProfileViewUserObjects,
  GenerateProfileViewUserOptions,
  GenerateProfileViewUsersOptions,
  generateProjectBidInfoObject,
  GenerateProjectBidInfoOptions,
  generateProjectBookmarkObject,
  GenerateProjectBookmarkOptions,
  generateProjectBudgetOptions,
  GenerateProjectBudgetOptionsOptions,
  generateProjectCollaborationObject,
  generateProjectCollaborationObjects,
  GenerateProjectCollaborationOptions,
  GenerateProjectCollaborationsOptions,
  generateProjectFeedObjects,
  GenerateProjectFeedOptions,
  generateProjectObject,
  GenerateProjectOptions,
  generateProjectUpgradeFeeObjects,
  GenerateProjectUpgradeFeesOptions,
  generateProjectViewBidObjects,
  GenerateProjectViewBidsOptions,
  generateProjectViewProjectObject,
  GenerateProjectViewProjectOptions,
  generateProjectViewUserObject,
  generateProjectViewUserObjects,
  GenerateProjectViewUserOptions,
  GenerateProjectViewUsersOptions,
  generatePublicationObject,
  GeneratePublicationOptions,
  generateReactionTypeCountObject,
  GenerateReactionTypeCountObject,
  generateReactionTypeCountObjects,
  generateRecentProjectsAndContestsObjects,
  GenerateRecentProjectsAndContestsOptions,
  generateReferralInvitationCheckObject,
  GenerateReferralInvitationCheckOptions,
  generateReplyContestCommentObject,
  GenerateReplyContestCommentOptions,
  generateReviewObject,
  GenerateReviewOptions,
  generateReviewSkillObject,
  GenerateReviewSkillOptions,
  generateSearchActiveContestObject,
  GenerateSearchActiveContestOptions,
  generateSearchActiveProjectsObject,
  GenerateSearchActiveProjectsOptions,
  generateSearchUsersObjects,
  GenerateSearchUsersOptions,
  generateSimilarFreelancersObject,
  GenerateSimilarFreelancersOptions,
  generateSimilarShowcasesObject,
  GenerateSimilarShowcasesOptions,
  generateSiteStatsObject,
  GenerateSiteStatsOptions,
  generateSkillObjects,
  generateSuggestedSkillsObject,
  GenerateSuggestedSkillsOptions,
  generateTaxObject,
  GenerateTaxOptions,
  generateThread,
  generateThreadProjectObject,
  GenerateThreadProjectOptions,
  GenerateThreadsOptions,
  generateTimeTrackingPunches,
  GenerateTimeTrackingPunchesOptions,
  generateTimeTrackingSession,
  GenerateTimeTrackingSessionOptions,
  generateTopSkillObjects,
  GenerateTopSkillsOptions,
  generateUniversityObjects,
  GenerateUniversityOptions,
  generateUserBalanceObjects,
  generateUserBidLimitObject,
  GenerateUserBidLimitOptions,
  GenerateUserCalifornianStatusesOptions,
  generateUserCalifornianStatusObjects,
  generateUserContestCollaborationWhitelist,
  GenerateUserContestCollaborationWhitelistOption,
  generateUserDepositMethodsObjects,
  GenerateUserDepositMethodsOptions,
  generateUserEnterpriseObjects,
  GenerateUserEnterpriseOptions,
  generateUserGiveGetDetailsObject,
  GenerateUserGiveGetDetailsOptions,
  generateUserHasDuplicateIpObject,
  GenerateUserHasDuplicateIpOptions,
  generateUserHasGivenFeedbackObject,
  GenerateUserHasGivenFeedbackOptions,
  generateUserInfoObject,
  GenerateUserInfoOptions,
  generateUserObject,
  generateUserObjects,
  GenerateUserOptions,
  generateUserProfileObject,
  generateUserRequiresGdprObject,
  GenerateUserRequiresGdprOptions,
  generateUserSelfObject,
  GenerateUserSelfOptions,
  generateUserSkillObject,
  GenerateUserSkillOptions,
  generateUsersLocationObject,
  GenerateUsersLocationOptions,
  GenerateUsersOptions,
  GenerateUsersProfileOptions,
  GrantsCollection,
  GroupMembersCollection,
  GroupPermissionsCollection,
  GroupsCollection,
  GroupsSelfCollection,
  HourlyContractsCollection,
  LanguagesCollection,
  ManageViewOngoingBidsCollection,
  ManageViewOpenBidsCollection,
  MembershipBenefitsCollection,
  MembershipPackagesCollection,
  MembershipSubscriptionHistoryCollection,
  MembershipTrialsCollection,
  MessagesCollection,
  MilestonesCollection,
  NativeExchangeRatesCollection,
  NewsfeedCollection,
  NotificationsPreferencesCollection,
  OnBehalfProjectsCollection,
  OnlineOfflineCollection,
  PaymentShareMembersCollection,
  PaymentShareMembersSpentAmountCollection,
  PaymentShareTeamsCollection,
  PaymentShareWhitelistItemsCollection,
  PoolsCollection,
  PortfoliosCollection,
  PredictedSkillsCollection,
  PreferredBillingAgreementsCollection,
  ProfileViewUsersCollection,
  ProjectBidInfoCollection,
  ProjectBookmarksCollection,
  ProjectBudgetOptionsCollection,
  ProjectCollaborationsCollection,
  ProjectFeedCollection,
  ProjectsCollection,
  ProjectUpgradeFeesCollection,
  ProjectViewBidsCollection,
  ProjectViewProjectsCollection,
  ProjectViewUsersCollection,
  PublicationsCollection,
  ReactionsTypeCountCollection,
  ReferralInvitationCheckCollection,
  ReviewsCollection,
  ReviewsSkillsCollection,
  SearchActiveContestsCollection,
  SearchActiveProjectsCollection,
  SearchUsersCollection,
  SimilarFreelancersCollection,
  SimilarShowcasesCollection,
  SiteStatsCollection,
  SkillsCollection,
  SuggestedSkillsCollection,
  TaxCollection,
  ThreadProjectsCollection,
  ThreadsCollection,
  TimeTrackingPunchesCollection,
  TimeTrackingSessionCollection,
  TopSkillsCollection,
  UniversitiesCollection,
  UserBalancesCollection,
  UserBidLimitCollection,
  UserCalifornianStatusesCollection,
  UserContestCollaborationWhitelistCollection,
  UserDepositMethodsCollection,
  UserGiveGetDetailsCollection,
  UserHasDuplicateIpCollection,
  UserHasGivenFeedbackCollection,
  UserInfoCollection,
  UserRecentProjectsAndContestsCollection,
  UserRequiresGdprCollection,
  UsersCollection,
  UserSkillsCollection,
  UsersLocationCollection,
  UsersProfileCollection,
  UsersSelfCollection,
} from '@freelancer/datastore/collections';
import {
  DatastoreCollectionType,
  DatastoreFetchCollectionType,
  DatastorePushCollectionType,
  DatastoreUpdateCollectionType,
} from '@freelancer/datastore/core';
import {
  DatastoreTestingController,
  generateId,
  MutationPropagator,
  PushTransformer,
  RequestErrorCode,
  SearchTransformer,
  UpdateTransformer,
} from '@freelancer/datastore/testing';
import { take } from 'rxjs/operators';

let globalAuth: AuthServiceInterface | undefined;
let globalDatastoreController: DatastoreTestingController | undefined;

function getAuth(): AuthServiceInterface {
  if (!globalAuth) {
    throw new Error('Missing Auth. Did you forget to call `setAuth()?`');
  }

  return globalAuth;
}

export function setAuth(auth: AuthServiceInterface) {
  globalAuth = auth;
}

function getDatastoreController(): DatastoreTestingController {
  if (!globalDatastoreController) {
    throw new Error('Missing Datastore. Did you forget to call `setAuth()?`');
  }

  return globalDatastoreController;
}

export function setDatastoreController(
  datastoreController: DatastoreTestingController,
) {
  globalDatastoreController = datastoreController;
}

function createDoc<
  C extends DatastoreCollectionType,
  Config,
  DocumentType extends C['DocumentType'] = C['DocumentType']
>(
  collectionName: C['Name'],
  generateDocument: (config?: Config) => DocumentType,
): (config?: Config) => Promise<DocumentType>;
function createDoc<
  C extends DatastoreCollectionType,
  Config,
  DocumentType extends C['DocumentType'] = C['DocumentType']
>(
  collectionName: C['Name'],
  generateDocument: (config: Config) => DocumentType,
): (config: Config) => Promise<DocumentType>;
function createDoc<
  C extends DatastoreCollectionType,
  Config,
  DocumentType extends C['DocumentType'] = C['DocumentType']
>(
  collectionName: C['Name'],
  generateDocument: (config: Config) => DocumentType,
): (config: Config) => Promise<DocumentType> {
  return async (config: Config) => {
    const document = generateDocument(config);
    await getDatastoreController().createRawDocument(collectionName, document);
    return document;
  };
}

function createDocs<
  C extends DatastoreCollectionType,
  Config,
  DocumentType extends C['DocumentType'] = C['DocumentType']
>(
  collectionName: C['Name'],
  generateDocuments: (config?: Config) => readonly DocumentType[],
): (config?: Config) => Promise<readonly DocumentType[]>;
function createDocs<
  C extends DatastoreCollectionType,
  Config,
  DocumentType extends C['DocumentType'] = C['DocumentType']
>(
  collectionName: C['Name'],
  generateDocuments: (config: Config) => readonly DocumentType[],
): (config: Config) => Promise<readonly DocumentType[]>;
function createDocs<
  C extends DatastoreCollectionType,
  Config,
  DocumentType extends C['DocumentType'] = C['DocumentType']
>(
  collectionName: C['Name'],
  generateDocuments: (config: Config) => readonly DocumentType[],
): (config: Config) => Promise<readonly DocumentType[]> {
  return async (config: Config) => {
    const documents = generateDocuments(config);
    await Promise.all(
      documents.map(document =>
        getDatastoreController().createRawDocument(collectionName, document),
      ),
    );
    return documents;
  };
}

// #region Controller functions

export function createRawDocument<
  C extends DatastoreCollectionType & DatastorePushCollectionType
>(collectionName: C['Name'], document: C['DocumentType']) {
  return getDatastoreController().createRawDocument<C>(
    collectionName,
    document,
  );
}

export function resetDatastoreState<C extends DatastoreCollectionType>(
  collectionName?: C['Name'],
) {
  return getDatastoreController().resetState<C>(collectionName);
}

export function printDatastoreState() {
  return getDatastoreController().printState();
}

export function addMutationPropagator<
  C1 extends DatastoreCollectionType & DatastorePushCollectionType,
  C2 extends DatastoreCollectionType & DatastorePushCollectionType
>(propagator: MutationPropagator<C1, C2>) {
  return getDatastoreController().addMutationPropagator<C1, C2>(propagator);
}

export function addPushTransformer<
  C extends DatastoreCollectionType & DatastorePushCollectionType
>(collectionName: C['Name'], transformer: PushTransformer<C>) {
  return getDatastoreController().addPushTransformer<C>(
    collectionName,
    transformer,
  );
}

export function addUpdateTransformer<
  C extends DatastoreCollectionType & DatastoreUpdateCollectionType
>(collectionName: C['Name'], transformer: UpdateTransformer<C>) {
  return getDatastoreController().addUpdateTransformer<C>(
    collectionName,
    transformer,
  );
}

export function addSearchTransformer<C extends DatastoreCollectionType>(
  collectionName: C['Name'],
  transformer: SearchTransformer<C>,
) {
  return getDatastoreController().addSearchTransformer<C>(
    collectionName,
    transformer,
  );
}

export function makeCollectionFail<
  C extends DatastoreCollectionType & DatastoreFetchCollectionType
>(collectionName: C['Name'], errorCode: RequestErrorCode<C> = 'UNKNOWN_ERROR') {
  return getDatastoreController().makeCollectionFail<C>(
    collectionName,
    errorCode,
  );
}

export function makeCollectionPending<
  C extends DatastoreCollectionType & DatastoreFetchCollectionType
>(collectionName: C['Name']) {
  return getDatastoreController().makeCollectionPending<C>(collectionName);
}

// #endregion Controller functions

// #region Helper functions for creating account.

export async function signup(userOptions: GenerateUserOptions = {}) {
  const userId = userOptions.userId || generateId();

  const isLoggedIn = await getAuth().isLoggedIn().pipe(take(1)).toPromise();
  if (!isLoggedIn) {
    console.warn(
      `User ${userId} has been created before calling signupAndLogin - it will not be visible to logged in users`,
    );
  }

  const user = await createDoc<UsersCollection, GenerateUserOptions>(
    'users',
    generateUserObject,
  )({ userId, ...userOptions });

  return user;
}

export async function signupAndLogin(
  userOptions: GenerateUserOptions = {},
  userSelfOptions: GenerateUserSelfOptions = {},
) {
  // We have to "login" first because otherwise the datastore documents are not
  // accessible to the user that just signed up. See `signup()`

  // Log in
  const userId = userOptions.userId || generateId();
  getAuth().setSession(userId.toString(), '');

  const user = await createDoc<UsersCollection, GenerateUserOptions>(
    'users',
    generateUserObject,
  )({ userId, ...userOptions });

  await createDoc<UsersSelfCollection, GenerateUserOptions>(
    'usersSelf',
    generateUserSelfObject,
  )({ userId, ...userSelfOptions });

  return user;
}

// #endregion Helper functions for creating account.

// #region Single object creation functions. These should all be singular.

export const createBidRestriction = createDoc<
  BidRestrictionsCollection,
  GenerateBidRestrictionsOptions
>('bidRestrictions', generateBidRestrictionsObject);

export const createBidSummary = createDoc<
  BidSummariesCollection,
  GenerateBidSummariesOptions
>('bidSummaries', generateBidSummariesObject);

export const createBidUpgradeFee = createDoc<
  BidUpgradeFeesCollection,
  GenerateBidUpgradeFeesOptions
>('bidUpgradeFees', generateBidUpgradeFeesObject);

export const createBillingAgreement = createDoc<
  BillingAgreementsCollection,
  GenerateBillingAgreementOptions
>('billingAgreements', generateBillingAgreementObject);

export const createCanViewEmployerProfile = createDoc<
  CanViewEmployerProfileCollection,
  GenerateCanViewEmployerProfileOptions
>('canViewEmployerProfile', generateCanViewEmployerProfileObject);

export const createCategoryPageContent = createDoc<
  CategoryPageContentCollection,
  GenerateCategoryPageContentOptions
>('categoryPageContent', generateCategoryPageContent);

export const createCertification = createDoc<
  CertificationsCollection,
  GenerateCertificationOptions
>('certifications', generateCertificationObject);

export const createContest = createDoc<
  ContestsCollection,
  GenerateContestOptions
>('contests', generateContestObject);

export const createContestEntry = createDoc<
  ContestEntriesCollection,
  GenerateContestEntryOptions
>('contestEntries', generateContestEntryObject);

export const createContestViewContest = createDoc<
  ContestViewContestsCollection,
  GenerateContestViewContestOptions
>('contestViewContests', generateContestViewContestObject);

export const createDomain = createDoc<DomainsCollection, {}>(
  'domains',
  generateDomainObject,
);

export const createEducation = createDoc<
  EducationsCollection,
  GenerateEducationOptions
>('educations', generateEducationObject);

export const createEncodedUrl = createDoc<
  EncodedUrlCollection,
  GenerateEncodedUrlOptions
>('encodedUrl', generateEncodedUrlObject);

export const createExperience = createDoc<
  ExperiencesCollection,
  GenerateExperienceOptions
>('experiences', generateExperienceObject);

export const createFreelancerReputation = createDoc<
  FreelancerReputationsCollection,
  GenerateFreelancerReputationOptions
>('freelancerReputations', generateFreelancerReputationsObject);

export const createFreelancerReputationsRehireRate = createDoc<
  FreelancerReputationsRehireRatesCollection,
  GenerateFreelancerReputationOptions
>(
  'freelancerReputationsRehireRates',
  generateFreelancerReputationsRehireRatesObject,
);

export const createHourlyContract = createDoc<
  HourlyContractsCollection,
  GenerateHourlyContractOptions
>('hourlyContracts', generateHourlyContractObject);

export const createLanguage = createDoc<LanguagesCollection, {}>(
  'languages',
  generateLanguagesObject,
);

export const createMembershipBenefit = createDoc<
  MembershipBenefitsCollection,
  GenerateMembershipBenefitOptions
>('membershipBenefits', generateMembershipBenefitObject);

export const createMessage = createDoc<
  MessagesCollection,
  GenerateMessageOptions
>('messages', generateMessage);

export const createMilestone = createDoc<
  MilestonesCollection,
  GenerateMilestoneOptions
>('milestones', generateMilestoneObject);

export const createNewsfeedProjectAccepted = createDoc<
  NewsfeedCollection,
  GenerateNotificationProjectAcceptedOptions,
  ReturnType<typeof generateNotificationAcceptedObject>
>('newsfeed', generateNotificationAcceptedObject);

export const createNewsfeedProjectAwarded = createDoc<
  NewsfeedCollection,
  GenerateNotificationAwardOptions,
  ReturnType<typeof generateNotificationAwardObject>
>('newsfeed', generateNotificationAwardObject);

export const createNewsfeedProjectBidOn = createDoc<
  NewsfeedCollection,
  GenerateNotificationBidOptions,
  ReturnType<typeof generateNotificationBidObject>
>('newsfeed', generateNotificationBidObject);

export const createNewsfeedBookmarkedProjectAwarded = createDoc<
  NewsfeedCollection,
  GenerateNotificationBookmarkedProjecAwardedOptions,
  ReturnType<typeof generateNotificationBookmarkedProjecAwardedObject>
>('newsfeed', generateNotificationBookmarkedProjecAwardedObject);

/* This actually creates a single portfolio item, not a whole portfolio */
export const createPortfolio = createDoc<
  PortfoliosCollection,
  GeneratePortfolioOptions
>('portfolios', generatePortfolioObject);

export const createProfileViewUser = createDoc<
  ProfileViewUsersCollection,
  GenerateProfileViewUserOptions
>('profileViewUsers', generateProfileViewUserObject);

export const createProjectBidInfo = createDoc<
  ProjectBidInfoCollection,
  GenerateProjectBidInfoOptions
>('projectBidInfo', generateProjectBidInfoObject);

export const createProjectBookmark = createDoc<
  ProjectBookmarksCollection,
  GenerateProjectBookmarkOptions
>('projectBookmarks', generateProjectBookmarkObject);

export const createProject = createDoc<
  ProjectsCollection,
  GenerateProjectOptions
>('projects', generateProjectObject);

export const createThreadProject = createDoc<
  ThreadProjectsCollection,
  GenerateThreadProjectOptions
>('threadProjects', generateThreadProjectObject);

export const createProjectViewProject = createDoc<
  ProjectViewProjectsCollection,
  GenerateProjectViewProjectOptions
>('projectViewProjects', generateProjectViewProjectObject);

export const createProjectViewUser = createDoc<
  ProjectViewUsersCollection,
  GenerateProjectViewUserOptions
>('projectViewUsers', generateProjectViewUserObject);

export const createPublication = createDoc<
  PublicationsCollection,
  GeneratePublicationOptions
>('publications', generatePublicationObject);

export const createReview = createDoc<ReviewsCollection, GenerateReviewOptions>(
  'reviews',
  generateReviewObject,
);

export const createReviewSkill = createDoc<
  ReviewsSkillsCollection,
  GenerateReviewSkillOptions
>('reviewsSkills', generateReviewSkillObject);

export const createReferralInvitationCheck = createDoc<
  ReferralInvitationCheckCollection,
  GenerateReferralInvitationCheckOptions
>('referralInvitationCheck', generateReferralInvitationCheckObject);

export const createSimilarFreelancers = createDoc<
  SimilarFreelancersCollection,
  GenerateSimilarFreelancersOptions
>('similarFreelancers', generateSimilarFreelancersObject);

export const createSimilarShowcases = createDoc<
  SimilarShowcasesCollection,
  GenerateSimilarShowcasesOptions
>('similarShowcases', generateSimilarShowcasesObject);

export const createSiteStat = createDoc<
  SiteStatsCollection,
  GenerateSiteStatsOptions
>('siteStats', generateSiteStatsObject);

export const createSuggestedSkills = createDoc<
  SuggestedSkillsCollection,
  GenerateSuggestedSkillsOptions
>('suggestedSkills', generateSuggestedSkillsObject);

export const createSearchActiveContests = createDoc<
  SearchActiveContestsCollection,
  GenerateSearchActiveContestOptions
>('searchActiveContests', generateSearchActiveContestObject);

export const createSearchActiveProjects = createDoc<
  SearchActiveProjectsCollection,
  GenerateSearchActiveProjectsOptions
>('searchActiveProjects', generateSearchActiveProjectsObject);

export const createTax = createDoc<TaxCollection, GenerateTaxOptions>(
  'tax',
  generateTaxObject,
);

export const createTimeTrackingPunches = createDocs<
  TimeTrackingPunchesCollection,
  GenerateTimeTrackingPunchesOptions
>('timeTrackingPunches', generateTimeTrackingPunches);

export const createTimeTrackingSession = createDoc<
  TimeTrackingSessionCollection,
  GenerateTimeTrackingSessionOptions
>('timeTrackingSession', generateTimeTrackingSession);

export const createThread = createDoc<
  ThreadsCollection,
  GenerateThreadsOptions
>('threads', generateThread);

export const createUserBidLimit = createDoc<
  UserBidLimitCollection,
  GenerateUserBidLimitOptions
>('userBidLimit', generateUserBidLimitObject);

export const createUserGiveGetDetail = createDoc<
  UserGiveGetDetailsCollection,
  GenerateUserGiveGetDetailsOptions
>('userGiveGetDetails', generateUserGiveGetDetailsObject);

export const createUserHasDuplicateIp = createDoc<
  UserHasDuplicateIpCollection,
  GenerateUserHasDuplicateIpOptions
>('userHasDuplicateIp', generateUserHasDuplicateIpObject);

export const createUserHasGivenFeedback = createDoc<
  UserHasGivenFeedbackCollection,
  GenerateUserHasGivenFeedbackOptions
>('userHasGivenFeedback', generateUserHasGivenFeedbackObject);

export const createUserInfo = createDoc<
  UserInfoCollection,
  GenerateUserInfoOptions
>('userInfo', generateUserInfoObject);

export const createUserLocation = createDoc<
  UsersLocationCollection,
  GenerateUsersLocationOptions
>('usersLocation', generateUsersLocationObject);

export const createUserRequiresGdpr = createDoc<
  UserRequiresGdprCollection,
  GenerateUserRequiresGdprOptions
>('userRequiresGdpr', generateUserRequiresGdprObject);

export const createUser = createDoc<UsersCollection, GenerateUserOptions>(
  'users',
  generateUserObject,
);

export const createUsersProfile = createDoc<
  UsersProfileCollection,
  GenerateUsersProfileOptions
>('usersProfile', generateUserProfileObject);

export const createUsersSelf = createDoc<
  UsersSelfCollection,
  GenerateUserOptions
>('usersSelf', generateUserSelfObject);

// #endregion Single object creation functions. These should all be singular.

// #region Multiple object creation functions. These should all be plural.

export const createBanners = createDocs<BannersCollection, {}>(
  'banners',
  generateBannerObjects,
);

export const createBids = createDocs<BidsCollection, GenerateBidsOptions>(
  'bids',
  generateBidObjects,
);

export const createProjectCollaboration = createDoc<
  ProjectCollaborationsCollection,
  GenerateProjectCollaborationOptions
>('projectCollaborations', generateProjectCollaborationObject);

export const createProjectCollaborations = createDocs<
  ProjectCollaborationsCollection,
  GenerateProjectCollaborationsOptions
>('projectCollaborations', generateProjectCollaborationObjects);

export const createContestEntries = createDocs<
  ContestEntriesCollection,
  GenerateContestEntriesOptions
>('contestEntries', generateContestEntryObjects);

export const createContestViewEntryIds = createDoc<
  ContestViewEntryIdsCollection,
  GenerateContestViewEntryIdsOptions
>('contestViewEntryIds', generateContestViewEntryIdsObject);

export const createContestFees = createDoc<
  ContestFeesCollection,
  GenerateContestFeesOptions
>('contestFees', generateContestFeesObject);

export const createContestQuickviewEntries = createDocs<
  ContestQuickviewEntriesCollection,
  GenerateContestQuickviewEntriesOptions
>('contestQuickviewEntries', generateContestQuickviewEntryObjects);

export const createContestViewEntries = createDocs<
  ContestViewEntriesCollection,
  GenerateContestViewEntriesOptions
>('contestViewEntries', generateContestViewEntryObjects);

export const createContestBudgetRanges = createDocs<
  ContestBudgetRangesCollection,
  {}
>('contestBudgetRanges', generateContestBudgetRangesObjects);

export const createCountries = createDocs<
  CountriesCollection,
  GenerateCountriesOptions
>('countries', generateCountryObjects);

export const createCurrencies = createDocs<CurrenciesCollection, {}>(
  'currencies',
  generateCurrencyObjects,
);

export const createCurrencyIncludingExternal = createDocs<
  CurrenciesIncludingExternalCollection,
  {}
>('currenciesIncludingExternal', generateCurrencyIncludingExternalObjects);

export const createDashboardWidgets = createDocs<
  DashboardWidgetsCollection,
  GenerateDashboardWidgetsOptions
>('dashboardWidgets', generateDashboardWidgetObjects);

export const createExams = createDocs<ExamsCollection, {}>(
  'exams',
  generateExamObjects,
);

export const createDepositPageVars = createDocs<
  DepositPageVarsCollection,
  GenerateDepositPageVarsOptions
>('depositPageVars', generateDepositPageVarsObjects);

export const createUserDepositMethods = createDocs<
  UserDepositMethodsCollection,
  GenerateUserDepositMethodsOptions
>('userDepositMethods', generateUserDepositMethodsObjects);

export const createExchangeRates = createDocs<
  ExchangeRatesCollection,
  GenerateExchangeRatesOptions
>('exchangeRates', (options: GenerateExchangeRatesOptions) =>
  options.currencyCodes.map(generateExchangeRateObject),
);

export const createNativeExchangeRates = createDocs<
  NativeExchangeRatesCollection,
  GenerateNativeExchangeRatesOptions
>('nativeExchangeRates', (options: GenerateNativeExchangeRatesOptions) =>
  options.currencyCodes.map(generateNativeExchangeRateObject),
);

export const createFreelancerReputations = createDocs<
  FreelancerReputationsCollection,
  GenerateFreelancerReputationsOptions
>('freelancerReputations', generateFreelancerReputationsObjects);

export const createFreelancerReputationsRehireRates = createDocs<
  FreelancerReputationsRehireRatesCollection,
  GenerateFreelancerReputationsOptions
>(
  'freelancerReputationsRehireRates',
  generateFreelancerReputationsRehireRatesObjects,
);

export const createManageViewOpenBids = createDocs<
  ManageViewOpenBidsCollection,
  GenerateManageViewOpenBidsOptions
>('manageViewOpenBids', generateManageViewOpenBidsObjects);

export const createManageViewOngoingBids = createDocs<
  ManageViewOngoingBidsCollection,
  GenerateManageViewOngoingBidsOptions
>('manageViewOngoingBids', generateManageViewOngoingBidObjects);

export const createMessages = createDocs<
  MessagesCollection,
  GenerateMessagesOptions
>('messages', generateMessages);

export const createNotificationsPreferences = createDocs<
  NotificationsPreferencesCollection,
  GenerateNotificationPreferenceObjectsOptions
>('notificationsPreferences', generateNotificationPreferenceObjects);

export const createOnlineOffline = createDocs<
  OnlineOfflineCollection,
  GenerateOnlineOfflineOptions
>('onlineOffline', generateOnlineOfflineObjects);

export const createPools = createDocs<
  PoolsCollection,
  readonly GeneratePoolOptions[]
>('pools', generatePoolObjects);

export const createAdminPools = createDocs<
  AdminPoolsCollection,
  readonly GenerateAdminPoolOptions[]
>('adminPools', generateAdminPoolObjects);

/* This actually creates a list of portfolio items, not multiple portfolios */
export const createPortfolios = createDocs<
  PortfoliosCollection,
  GeneratePortfoliosOptions
>('portfolios', generatePortfolioObjects);

export const createPredictedSkill = createDoc<
  PredictedSkillsCollection,
  GeneratePredictedSkillsOptions
>('predictedSkills', generatePredictedSkillsObject);

export const createPreferredBillingAgreement = createDoc<
  PreferredBillingAgreementsCollection,
  GeneratePreferredBillingAgreementOptions
>('preferredBillingAgreements', generatePreferredBillingAgreementObject);

export const createProfileViewUsers = createDocs<
  ProfileViewUsersCollection,
  GenerateProfileViewUsersOptions
>('profileViewUsers', generateProfileViewUserObjects);

export const createProjectBudgetOptions = createDocs<
  ProjectBudgetOptionsCollection,
  GenerateProjectBudgetOptionsOptions
>('projectBudgetOptions', generateProjectBudgetOptions);

export const createProjectFeed = createDocs<
  ProjectFeedCollection,
  GenerateProjectFeedOptions
>('projectFeed', generateProjectFeedObjects);

export const createProjectUpgradeFees = createDocs<
  ProjectUpgradeFeesCollection,
  GenerateProjectUpgradeFeesOptions
>('projectUpgradeFees', generateProjectUpgradeFeeObjects);

export const createProjectViewBids = createDocs<
  ProjectViewBidsCollection,
  GenerateProjectViewBidsOptions
>('projectViewBids', generateProjectViewBidObjects);

export const createProjectViewUsers = createDocs<
  ProjectViewUsersCollection,
  GenerateProjectViewUsersOptions
>('projectViewUsers', generateProjectViewUserObjects);

export const createSearchUsers = createDocs<
  SearchUsersCollection,
  GenerateSearchUsersOptions
>('searchUsers', generateSearchUsersObjects);

export const createSkills = createDocs<SkillsCollection, {}>(
  'skills',
  generateSkillObjects,
);

export const createTopSkills = createDocs<
  TopSkillsCollection,
  GenerateTopSkillsOptions
>('topSkills', generateTopSkillObjects);

export const createUserSkills = createDoc<
  UserSkillsCollection,
  GenerateUserSkillOptions
>('userSkills', generateUserSkillObject);

export const createUniversities = createDocs<
  UniversitiesCollection,
  GenerateUniversityOptions
>('universities', generateUniversityObjects);

export const createUserBalances = createDocs<UserBalancesCollection, {}>(
  'userBalances',
  generateUserBalanceObjects,
);

export const createUserCalifornianStatuses = createDocs<
  UserCalifornianStatusesCollection,
  GenerateUserCalifornianStatusesOptions
>('userCalifornianStatuses', generateUserCalifornianStatusObjects);

export const createUserRecentProjectsAndContests = createDocs<
  UserRecentProjectsAndContestsCollection,
  GenerateRecentProjectsAndContestsOptions
>('userRecentProjectsAndContests', generateRecentProjectsAndContestsObjects);

export const createUsers = createDocs<UsersCollection, GenerateUsersOptions>(
  'users',
  generateUserObjects,
);

export const createOnBehalfProject = createDoc<
  OnBehalfProjectsCollection,
  GenerateOnBehalfProjectOptions
>('onBehalfProjects', generateOnBehalfProject);

export const createCustomFieldInfoConfigurations = createDocs<
  CustomFieldInfoConfigurationsCollection,
  readonly GenerateCustomFieldInfoConfigurationOptions[]
>('customFieldInfoConfigurations', generateCustomFieldInfoConfigurationObjects);

export const createGroups = createDocs<
  GroupsCollection,
  readonly GenerateGroupOptions[]
>('groups', generateGroupsObject);

export const createGroupsSelf = createDocs<
  GroupsSelfCollection,
  GenerateGroupSelfOptions
>('groupsSelf', generateGroupsSelf);

export const createGroupMembers = createDocs<
  GroupMembersCollection,
  readonly GenerateGroupMemberOptions[]
>('groupMembers', generateGroupMembersObject);

export const createGroupPermissions = createDocs<
  GroupPermissionsCollection,
  GenerateGroupPermissionsOptions
>('groupPermissions', generateGroupPermissionsObject);

export const createFeedPost = createDoc<
  FeedPostsCollection,
  GenerateFeedPostsOptions
>('feedPosts', generateFeedPostObjects);

export const createFeedMeta = createDoc<
  FeedMetaCollection,
  GenerateFeedMetaOptions
>('feedMeta', generateFeedMetaObjects);

export const createFeedItem = createDoc<FeedCollection, GenerateFeedOptions>(
  'feed',
  generateFeedObject,
);

export const createCommentFeed = createDoc<
  CommentFeedsCollection,
  GenerateCommentFeedOptions
>('commentFeeds', generateCommentFeedObject);

export const createGrants = createDocs<
  GrantsCollection,
  readonly GenerateGrantItemOptions[]
>('grants', generateGrantsObjects);

export const createParentContestComment = createDoc<
  ContestCommentsCollection,
  GenerateParentContestCommentOptions
>('contestComments', generateParentContestCommentObject);

export const createReplyContestComment = createDoc<
  ContestCommentsCollection,
  GenerateReplyContestCommentOptions
>('contestComments', generateReplyContestCommentObject);

export const createEnterprises = createDocs<
  EnterprisesCollection,
  readonly GenerateEnterpriseOptions[]
>('enterprises', generateEnterpriseObjects);

export const createAdminEnterprises = createDocs<
  AdminEnterprisesCollection,
  readonly GenerateAdminEnterpriseOptions[]
>('adminEnterprises', generateAdminEnterpriseObjects);

export const createAdminUserEnterprises = createDocs<
  AdminUserEnterprisesCollection,
  readonly GenerateUserEnterpriseOptions[]
>('adminUserEnterprises', generateUserEnterpriseObjects);

export const createReactionsTypeCount = createDocs<
  ReactionsTypeCountCollection,
  readonly GenerateReactionTypeCountObject[]
>('reactionsTypeCount', generateReactionTypeCountObjects);

export const createReactionTypeCount = createDoc<
  ReactionsTypeCountCollection,
  GenerateReactionTypeCountObject
>('reactionsTypeCount', generateReactionTypeCountObject);

export const createComments = createDocs<
  CommentsCollection,
  readonly GenerateCommentOption[]
>('comments', generateCommentObjects);

export const createComment = createDoc<
  CommentsCollection,
  GenerateCommentOption
>('comments', generateCommentObject);

export const createUserContestCollaborationWhitelist = createDoc<
  UserContestCollaborationWhitelistCollection,
  GenerateUserContestCollaborationWhitelistOption
>(
  'userContestCollaborationWhitelist',
  generateUserContestCollaborationWhitelist,
);

export const createPaymentShareWhitelistItem = createDoc<
  PaymentShareWhitelistItemsCollection,
  GeneratePaymentShareWhitelistItemOptions
>('paymentShareWhitelistItems', generatePaymentShareWhitelistItemObject);

export const createPaymentShareTeams = createDoc<
  PaymentShareTeamsCollection,
  GeneratePaymentShareTeamOptions
>('paymentShareTeams', generatePaymentShareTeamObject);

export const createPaymentShareMembers = createDoc<
  PaymentShareMembersCollection,
  GeneratePaymentShareMemberOptions
>('paymentShareMembers', generatePaymentShareMemberObject);

export const createPaymentShareMembersSpentAmount = createDoc<
  PaymentShareMembersSpentAmountCollection,
  GeneratePaymentShareMemberSpentAmountOptions
>(
  'paymentShareMembersSpentAmount',
  generatePaymentShareMemberSpentAmountObject,
);

export const createEnterpriseBillingAgreementBalance = createDoc<
  EnterpriseBillingAgreementsBalanceCollection,
  GenerateEnterpriseBillingAgreementsBalanceOptions
>(
  'enterpriseBillingAgreementsBalance',
  generateEnterpriseBillingAgreementsBalance,
);

export const createMembershipSubscriptionHistory = createDocs<
  MembershipSubscriptionHistoryCollection,
  GenerateMembershipSubscriptionHistoryOptions
>(
  'membershipSubscriptionHistory',
  generateMembershipSubscriptionHistoryObjects,
);

export const createMembershipPackages = createDocs<
  MembershipPackagesCollection,
  {}
>('membershipPackages', generateMembershipPackagesObjects);

export const createMembershipTrials = createDocs<
  MembershipTrialsCollection,
  {}
>('membershipTrials', generateMembershipTrialsObjects);

// #endregion Multiple object creation functions. These should all be plural.
